export default "__VITE_ASSET__CE3h$k4y__"